import React from 'react';
import Url from '../services/Url';
import Constants from '../Shared/Constants';
import SlackLogo from '../assets/img/slack-logo.svg';
import TeamsLogo from '../assets/img/teams-logo.svg';

class Connections extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const profile = this.props.profile;
    const connections = profile.connections;

    const slackButtonText = connections.length
      ? 'Connect another Slack team'
      : 'Connect via Slack';

    const teamsButtonText = connections.length
      ? 'Connect another Teams team'
      : 'Connect via Teams';

    const profileList = connections.length
      ? <>
          <span>Your connected profiles</span><br />
          <ul>
            {connections.map(customer => {
              const icon = customer.platform === 'teams'
                ? <img src={TeamsLogo} alt="Teams" className="platform-icon" />
                : <img src={SlackLogo} alt="Slack" className="platform-icon" />;
              return <li key={customer.uuid}><strong>{customer.tname || 'Personal Account'}</strong> {icon}</li>;
            })}
          </ul>
        </>
      : <>
          <br />No team profiles connected yet.
        </>;

    return (
      <>
        <div className="paragraph">
          Getting {Constants.AppName} in any of your connected team profiles updates
          your <strong>{Constants.GlobalKarmuhNameLowercase}</strong> score.<br />
          {profileList}

          <div className="dual-cta mt-4">
            <a href={Url.slackConnectProfileSignIn()}
              id="connect-account-slack"
              className="slack-signin-btn"
              style={{
                alignItems: 'center',
                color: '#000',
                backgroundColor: '#fff',
                border: '1px solid #ddd',
                borderRadius: '4px',
                display: 'inline-flex',
                fontFamily: 'Lato, sans-serif',
                fontSize: '16px',
                fontWeight: '600',
                height: '48px',
                justifyContent: 'center',
                textDecoration: 'none',
                paddingLeft: '24px',
                paddingRight: '24px',
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" style={{height: '20px', width: '20px', marginRight: '12px'}} viewBox="0 0 122.8 122.8">
                <path d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z" fill="#e01e5a"></path>
                <path d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z" fill="#36c5f0"></path>
                <path d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z" fill="#2eb67d"></path>
                <path d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z" fill="#ecb22e"></path>
              </svg>
              {slackButtonText}
            </a>
            <a href={Url.teamsConnectProfileSignIn()}
              id="connect-account-teams"
              className="ms-teams-signin-btn"
            >
              <img src={TeamsLogo} alt="Microsoft Teams logo" />
              {teamsButtonText}
            </a>
          </div>
        </div>
      </>
    );
  }
}

export default Connections;
